import React from 'react';
import styled, { css } from 'styled-components';

import { ChangeableEmailListProps } from '~/components/organism/SendEmailBlock/components/MessageHeader';

import MultiSelectEmailInput from '~/components/molecule/MultiSelectEmailInput';
import useGetEmailOptions from '../../hooks/useGetEmailOptions';
import NamedEmailLabel from '../NamedEmailLabel';
import RowLabel from '../RowLabel';

export type Props = {
  /** The label to show (Cc or Bcc) */
  rowLabel: string;

  /** The grid placement to use */
  grid: {
    start: string;
    end: string;
  };
  changeableEmailList: ChangeableEmailListProps;
  disabled?: boolean;
};

const MultipleEmailRow: React.FCC<Props> = ({
  grid,
  rowLabel,
  changeableEmailList,
  disabled,
  dataTestId,
}) => {
  let inputComponent;

  const selectedOptions = changeableEmailList.selectedValues;

  const { onAsyncSearch, loading } = useGetEmailOptions({
    selectedOptions,
  });

  if (changeableEmailList.readOnly) {
    const { namedEmailList } = changeableEmailList;

    inputComponent = (
      <>
        {namedEmailList.map((namedEmail, idx) => {
          const { name, email } = namedEmail;

          return (
            <NamedEmailLabel
              key={keyForIdx(rowLabel, idx)}
              name={name}
              email={email}
            />
          );
        })}
      </>
    );
  } else {
    const { onSelected, onRemoved } = changeableEmailList;

    inputComponent = (
      <MultiSelectEmailInput
        disabled={disabled}
        selectedOptions={selectedOptions}
        onSelected={onSelected}
        onRemoved={onRemoved}
        onAsyncSearch={onAsyncSearch}
        loading={loading}
      />
    );
  }
  return (
    <>
      <MultipleEmailLabel gridStart={grid.start} gridEnd={grid.end}>
        {rowLabel}
      </MultipleEmailLabel>
      <MultipleEmailInput
        gridStart={grid.start}
        gridEnd={grid.end}
        data-testid={dataTestId}
      >
        {inputComponent}
      </MultipleEmailInput>
    </>
  );
};

const keyForIdx = (rowLabel, idx) => `${rowLabel}-${idx}`;

type GridProps = {
  gridStart: string;
  gridEnd: string;
};
type LabelProps = GridProps;
const MultipleEmailLabel = styled(RowLabel)<LabelProps>`
  ${({ gridStart, gridEnd }) => css`
    grid-row: ${gridStart} / ${gridEnd};
    grid-column: label-start / label-end;
  `}
`;
type InputProps = GridProps;
const MultipleEmailInput = styled.div<InputProps>`
  ${({ gridStart, gridEnd }) => css`
    grid-row: ${gridStart} / ${gridEnd};
    grid-column: input-start / button-end;
  `}
`;

export default MultipleEmailRow;
